import React, { createContext, useContext } from 'react';
import { toast } from 'sonner';
import UIStrings from '@/Utils/UIStrings';

type NotificationContextType = {
    showSuccessToaster: (message: string, title?: string) => void;
    showFailToaster: (message?: string, title?: string) => void;
};

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

const NotificationContextProvider = NotificationContext.Provider;

export const NotificationProvider = ({ children }: React.PropsWithChildren) => {
    const showSuccessToaster = (message: string, title?: string) => {
        if (title) {
            toast.success(title, {
                description: message,
            });
        } else {
            toast.success(message);
        }
    };

    const showFailToaster = (
        message: string = `${UIStrings.SomethingWentWrong}. ${UIStrings.TryAgainLater}.`,
        title?: string,
    ) => {
        if (title) {
            toast.error(title, {
                description: message,
            });
        } else {
            toast.error(message);
        }
    };

    return (
        <NotificationContextProvider
            value={{
                showSuccessToaster,
                showFailToaster,
            }}
        >
            {children}
        </NotificationContextProvider>
    );
};

export function useNotificationContext() {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('NotificationContext must be used within the NotificationContext.Provider');
    }
    return context;
}
